import React from 'react';
import './MessagePreloader.css';

const MessagePreloader = () => (
  <div className="loader">
    Ожидание ответа
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </div>
);

export default MessagePreloader;
